import axios from 'axios'

import { parseResponse, handleError } from '@/_helpers/utils.js'

const state = {
  loading: true,
  error: null,
  vacancy: null
}

const actions = {
  fetchVacancy ({commit, state, dispatch}, id) {
    commit('fetch')

    return axios.get(`/1.0/admin/vacancies/${id}`)
      .then(response => {
        const data = parseResponse(response).data[0];

        commit('fetchSuccess', {data});
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, {root: true})
        commit('fetchFailure', error)
      })
  },

  updateVacancy ({ commit, state, dispatch }, data) {
    return axios.put(`/1.0/admin/vacancies/${data.id}`, data)
      .then(response => {
        const data = parseResponse(response).data[0];

        commit('fetchSuccess', {data});
      })
      .catch(err => {
        const error = handleError(err);

        commit('fetchFailure', error);
      })
  }
}

const mutations = {
  fetch (state) {
    state.loading = true
  },

  fetchSuccess (state, {data}) {
    state.vacancy = data
    state.loading = false
  },

  fetchFailure (state, err) {
    state.error = err
    state.loading = false
    console.error(err)
  },

  clear: state => {
    state.vacancy = null;
    state.current_vacancy_id = null;
  }
}

const getters = {
  loading (state, getters) {
    return state.loading
  },
  vacancy: (state, getters) => {
    return state.vacancy
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
